import { useTranslation } from "@opendash/core";
import { useNavigate } from "@opendash/router";
import { createComponent } from "@opendash/state";
import { Button } from "antd";
import React from "react";
import type { AppState } from "./App.state";

import { $parse } from "@opendash/plugin-parse";
import ReactMarkdown from "react-markdown";
import { ActionBar } from "./styles";

export const KnowledgeArtikelView = createComponent(
  function KnowledgeArtikelView({ state }: { state: AppState }) {
    const t = useTranslation();
    const navigate = useNavigate();

    if (!state.article) {
      return null;
    }

    state.useForceRender();

    return (
      <>
        {$parse.ui.getObjectPermission(state.article, "update") && (
          <ActionBar>
            {$parse.ui.getObjectPermission(state.article, "update") && (
              <Button
                children={t("knowledge:label.update_article")}
                onClick={() => {
                  state.updateContent(state.article);
                }}
              />
            )}
            {$parse.ui.getObjectPermission(state.article, "delete") && (
              <Button
                danger
                children={t("knowledge:label.delete_article")}
                onClick={() => {
                  state.deleteContent(state.article).then((deleted) => {
                    if (deleted) {
                      navigate("../..");
                    }
                  });
                }}
              />
            )}
          </ActionBar>
        )}
        <ReactMarkdown children={state.article.markdown} />
      </>
    );
  }
);
